import { createContext } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { FormValues } from '@/domain/termine/shared/types/CreateTermineInput';

export interface CreateTermineFormContextValue {
  loading: boolean;
  onSubmit: () => void;
  form: UseFormReturn<FormValues>;
}

export const CreateTermineFormContext =
  createContext<CreateTermineFormContextValue | null>(null);
